export default __webpack_public_path__ + "static/media/after_1_implants.90eec114.png";